import { collection, limit, orderBy, query, where } from "firebase/firestore";
import {
  useFirestore,
  useLoadFirestoreQuery,
} from "@/data/studio-react/firebase/useFirestore";

import { useMemo } from "react";
import { Invoice } from "types";

export function useCustomerInvoices(
  marketId: string,
  customerId: string | null,
  pagination: {
    page: number;
    perPage: number | undefined;
  }
) {
  let firestore = useFirestore();

  // Get customer's invoices (limited to 5 most recent)
  let invoicesQuery = useMemo(() => {
    if (!customerId) {
      return null;
    }
    return query(
      collection(firestore, `markets/${marketId}/invoices`),
      where(`customerId`, `==`, customerId),
      orderBy("createdAt", "desc"),
      limit(pagination.perPage ?? 5)
    );
  }, [marketId, customerId, firestore, pagination.perPage]);

  let invoicesLoadInfo = useLoadFirestoreQuery<Invoice>(invoicesQuery, {
    idField: "id",
  });

  return invoicesLoadInfo;
}
